import { render } from "./InspecaoSecao2.vue?vue&type=template&id=4b47f62b&scoped=true&ts=true"
import script from "./InspecaoSecao2.vue?vue&type=script&lang=ts"
export * from "./InspecaoSecao2.vue?vue&type=script&lang=ts"

import "./InspecaoSecao2.vue?vue&type=style&index=0&id=4b47f62b&scoped=true&lang=css"

import exportComponent from "D:\\RopeSeguros\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b47f62b"]])

export default __exports__